// extracted by mini-css-extract-plugin
export default {"navbar":"navbar--8Coo5","logo":"logo--8Coo5","megaMenu":"megaMenu--8Coo5","button":"button--8Coo5","modalButtonWrap":"modalButtonWrap--8Coo5","modalButton":"modalButton--8Coo5"};